module.exports = __webpack_public_path__ + "img/Key4.763e7cf9.gif";